import { jsx } from "react/jsx-runtime";
import { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Select } from "@perxis-auto/ui-kit/lib/components/Select";
import { APP } from "../../../../shared/config/app.js";
import "../../../../shared/config/env.js";
import "../../../../shared/config/events.js";
function FilterLocation({ value = [], options = [], filterSort, onChange, ...props }) {
  const clusters = useMemo(() => options.filter((option) => option.type === "cluster"), [options]);
  const { t } = useTranslation(APP.name);
  const cities = useMemo(() => {
    const items = options.filter((option) => option.type !== "cluster");
    if (filterSort) {
      return items.sort((a, b) => filterSort(a, b, { searchValue: props.searchValue || "" }));
    }
    return items;
  }, [options, filterSort, props.searchValue]);
  const resolvedValue = useMemo(() => {
    if (!clusters.length) {
      return value;
    }
    const valueWithClusters = [...value];
    for (const clusterOption of clusters) {
      const cityOptions = options.filter((option) => option.clusterId === clusterOption.value);
      if (!cityOptions.length) {
        continue;
      }
      const isAllCitiesSelected = cityOptions.every((option) => value.includes(option.value));
      if (isAllCitiesSelected) {
        valueWithClusters.unshift(clusterOption.value);
      }
    }
    return valueWithClusters;
  }, [value, options, clusters]);
  const handleLocationChange = useCallback(
    (selectedValues, selectedOptions) => {
      if (!onChange) {
        return;
      }
      if (!selectedValues || !selectedValues.length) {
        return onChange(selectedValues);
      }
      const removedClusters = resolvedValue.filter((v) => !selectedValues.includes(v));
      const newValues = selectedValues.reduce((acc, value2, index) => {
        const selectedOption = selectedOptions == null ? void 0 : selectedOptions[index];
        if (!selectedOption || removedClusters.includes(selectedOption.clusterId)) {
          return acc;
        }
        if (selectedOption.type !== "cluster") {
          return [...acc, value2];
        }
        if (resolvedValue.includes(value2)) {
          return acc;
        }
        const cityOptions = options.filter((option) => option.clusterId === value2);
        return Array.from(/* @__PURE__ */ new Set([...acc, ...cityOptions.map((option) => option.value)]));
      }, []);
      return onChange(newValues);
    },
    [onChange, options, resolvedValue]
  );
  return /* @__PURE__ */ jsx(
    Select,
    {
      mode: "multiple",
      label: t("widgets.filterItem.filterLocation.cityLabel"),
      onChange: handleLocationChange,
      options: [...clusters, ...cities],
      value: resolvedValue,
      maxTagCount: 1e3,
      maxTagTextLength: 12,
      filterOption: (input, option) => ((option == null ? void 0 : option.label) ?? "").toLowerCase().includes(input.toLowerCase()),
      showSearch: true,
      ...props
    }
  );
}
export {
  FilterLocation
};
